import i18n from 'i18next'
import styles from './ImageContainer.module.css'

const UserImage = ({ imageUrl, firstName = '', lastName = '', roundContainer = false }) => {
    const renderName = (
        <div className={`avatar-title text-uppercase border ${roundContainer && 'rounded-circle'} bg-light text-primary ${styles.avatarTitle}`}>
            {firstName ? firstName?.charAt(0).toUpperCase() + lastName?.charAt(0).toUpperCase() : `${i18n.t('button.edit')}`}
        </div>
    )

    return (
        <div className="avatar-lg rounded-circle flex-shrink-0">
            {imageUrl !== null && imageUrl !== '' ? (
                <img src={imageUrl} alt="Profile" className={`${styles.imageFitCover} ${roundContainer && 'rounded-circle'}`} />
            ) : (
                renderName
            )}
        </div>
    )
}

export default UserImage
